import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-199205f4")

_pushScopeId("data-v-199205f4")
const _hoisted_1 = { class: "p-col federation-listbox-container" }
const _hoisted_2 = { class: "kn-list-item p-d-flex p-flex-row" }
const _hoisted_3 = { class: "kn-list-item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_Listbox = _resolveComponent("Listbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.mode === 'available' ? _ctx.$t('workspace.federationDefinition.availableDatasets') : _ctx.$t('workspace.federationDefinition.selectedDatasets')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_Message, {
      class: "p-m-4",
      severity: "info",
      closable: false,
      style: _ctx.workspaceFederationDatasetListDescriptor.styles.message
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.mode === 'available' ? _ctx.$t('workspace.federationDefinition.availableDatasetsMessage') : _ctx.$t('workspace.federationDefinition.selectedDatasetsMessage')), 1)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_Listbox, {
      class: "kn-list listbox-container",
      listStyle: _ctx.workspaceFederationDatasetListDescriptor.styles.dsList,
      options: _ctx.dataset,
      filter: true,
      optionLabel: "name",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectDataset($event.value)))
    }, {
      empty: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      option: _withId((slotProps) => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
          ]),
          (_ctx.mode === 'available')
            ? (_openBlock(), _createBlock("i", {
                key: 0,
                class: "fas fa-info-circle dataset-info-icon",
                onClick: _withModifiers(($event: any) => (_ctx.$emit('showInfo', slotProps.option)), ["stop"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["listStyle", "options"])
  ]))
})